import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { CashAdvanceFilter } from '../../../models/cashAdvances/cash.advance.filter';

@Component({
	selector: 'cash-advance-filter',
	templateUrl: './cash-advance-filter.component.html',
	styleUrls: ['./cash-advance-filter.component.css']
})
export class CashAdvanceFilterComponent implements OnInit {
	showFilter: boolean = false;
	
	@Input() filter: CashAdvanceFilter = new CashAdvanceFilter();
	@Output() search: EventEmitter<CashAdvanceFilter> = new EventEmitter<CashAdvanceFilter>()
	
	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this._elementRef.nativeElement.contains(event.target))
			this.showFilter = false;
	}

	constructor(private _elementRef: ElementRef,) { }

	ngOnInit() {
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
	}

	onSearchClick() {
		this.search.emit(this.filter);
		this.showFilter = false;
	}

	onClearClick() {
		this.filter.dateRecievedFrom = null;
		this.filter.recieverId = null;
		this.filter.releasedById = null;
		this.filter.createdDate = null;
		this.filter.createdDateFrom = null;
		this.filter.createdDateTo = null;
		this.filter.createdBy = null;
		this.filter.updatedDate = null;
		this.filter.updatedBy = null;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/cashAdvances/cash-advance-filter/cash-advance-filter.component.ts